import { render, staticRenderFns } from "./CurrentSize.vue?vue&type=template&id=f6901728&scoped=true"
import script from "./CurrentSize.vue?vue&type=script&lang=js"
export * from "./CurrentSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6901728",
  null
  
)

export default component.exports